import { RootState } from '../reducers/types/root';

export function selectUserState(state: RootState) {
  return state.user;
}
